import * as React from 'react';
import AuditCore from '../AfrCore/AuditCore';

const Audit = (props: any) => {

    return (
        <React.Fragment>
            <AuditCore userRole="ENTITY_USER" />
        </React.Fragment>
    );
}

export default Audit;